import Vue from 'vue'

const Tags = {
  namespaced: true,

  state: {
    tag: {},
    tagName: null,
    tags: []
  },

  mutations: {
    setTags(state, tags) {
      state.tags = tags || []
    },
    setTag(state, tag) {
      state.tag = tag || {}
      state.tagName = state.tag.name
    }
  },

  actions: {
    async getAll({ commit }, { search } = {}) {
      const params = { search }
      const response = await Vue.axios.get('/tags', { params })
      const tags = response.data.data
      commit('setTags', tags)
      return tags
    },
    async get({ commit }, id) {
      let tag = {}
      if (id) {
        const response = await Vue.axios.get(`/tag/${id}`)
        tag = response.data.data
      }
      commit('setTag', tag)
      return tag
    },
    async createAndAdd({ dispatch }, { name, tags }) {
      const response = await Vue.axios.post('/tag', { name })
      const { id } = response.data.data
      await dispatch('getAll')
      tags.push(id)
    },
    async createOrUpdate({ commit, state }) {
      let response
      if (state.tag.id) {
        response = await Vue.axios.put(`/tag/${state.tag.id}`, state.tag)
      } else {
        response = await Vue.axios.post('/tag', state.tag)
      }
      commit('setTag', response.data.data)
    }
  }
}

export default Tags
